define('instrumentation/pageLoadTime', ['lib/underscore', 'instrumentation/log', 'instrumentation/performance-api'], function (_, log, performanceApi) {
    var PerfTimingNotAvailable = 'N/A';
    var allowedResourceInitiatorType = {
        link: 'CSS',                // Log css load time
        script: 'Script',           // Log script load time
        img: 'Img',                 // Log image load time
        css: 'CSSEmbedded',         // Log resources embedded in css, resource types can be figured out from resourceEntry.name
    };

    var resourceBlackList = [
        "va.v.liveperson.net",
        'nexus.ensighten.com/msadv/prod',
        'msntrademarketing.112.2o7.net',
        'www.facebook.com',
        '985-fgw-558.mktoresp.com',
        'munchkin.marketo.net',
        'connect.facebook.net',
        'googleads.g.doubleclick.net',
        'bat.bing.com',
        'www.googleadservices.com',
        'mscom.demdex.net',
        'browser.pipe.aria.microsoft.com'
    ];

    function logPageLoadTime() {
        var navigationTiming = window.performance.timing
          , networkLatency
          , networkStart
          , domReadyLatency
          , redirectCount
          , redirectTime
          , domProcessTime
          , responseStartResponseEndTime
          , requestStartResponseEndTime
          , fullPageLoadTime
          , serverConnectionTime
          , dnsLookupTime
          , eventLoadTime;

        // https://www.w3.org/TR/navigation-timing/#processing-model
        // Primary timings ------------------------------------------------------------------------
        // the total network time for the current request, i.e. the time it takes to resolve the host,
        // establish a connection, send the request (with all the cookies and data) and get the response page back
        // (excluding any redirects or additional resources that need to be fetched to render the page);
        // in case the data is retrieved from cache, this represents the time required to locate and get the data from the cache
        networkStart = navigationTiming.domainLookupEnd === navigationTiming.fetchStart
            ? navigationTiming.connectEnd === navigationTiming.fetchStart
                ? navigationTiming.requestStart
                : navigationTiming.connectStart
            : navigationTiming.domainLookupStart;
        networkLatency = navigationTiming.responseEnd - networkStart;
        log.trace("Network_Latency", networkLatency);

        // this attempts to detect any potential queuing/stalling at the browser, before really initiating the connection
        // (note that this is not the same with server-side queuing)
        // https://developers.google.com/web/tools/chrome-devtools/network-performance/reference#timing-explanation
        log.trace("Resource_Scheduling", networkStart - navigationTiming.fetchStart);

        // the time it takes for the browser to parse the document, load any additional resources required to build the DOM (e.g. scripts)
        // and spin-up the main event-loop for JS processing, once the HTML page has been downloaded;
        // a.k.a. this is the time it takes to fire $(document).ready() event from the moment the last byte of the page was received
        // (note that some of the resources, e.g. images, might not be completely downloaded at this time)
        domReadyLatency = navigationTiming.domContentLoadedEventEnd - navigationTiming.responseEnd;
        log.trace("Dom_Ready_Latency", domReadyLatency);

        if (window.performance.navigation) {
            // how many times the current request has been redirected before arriving at the right URL
            redirectCount = window.performance.navigation.redirectCount;
            log.trace("Redirect_Count", redirectCount);
            // the total time it took for the current request to be redirected to the right URL
            redirectTime = navigationTiming.redirectEnd - navigationTiming.redirectStart;
            log.trace("Redirect_Time", redirectTime);
        } else {
            log.trace("Redirect_Count", PerfTimingNotAvailable);
            log.trace("Redirect_Time", PerfTimingNotAvailable);
        }

        // the time it takes to load the page once it's received from the server
        // (this includes loading all CSS, script, frame resources, but not any AJAX requests or main page redirects)
        domProcessTime = navigationTiming.loadEventStart - navigationTiming.responseEnd;
        log.trace("Dom_Processing_Time", domProcessTime);

        // Additional timings ---------------------------------------------------------------------
        // the time it takes to download all the bytes in the response - this only includes the HTML page and *NOT* any of the resources (CSS, scripts etc.)
        responseStartResponseEndTime = navigationTiming.responseEnd - navigationTiming.responseStart;
        log.trace("Response_Start_Response_End_Time", responseStartResponseEndTime);

        // the time it takes to send all the bytes of the request, wait for the server to process the request, then receive all the bytes in the response
        // (not including downloading additional resources, e.g. CSS, scripts, etc.)
        requestStartResponseEndTime = navigationTiming.responseEnd - navigationTiming.requestStart;
        log.trace("Request_Start_Response_End_Time", requestStartResponseEndTime);

        // Other timings --------------------------------------------------------------------------
        // the overall time it takes from the moment the user clicked a link (or initiated a navigation in any other way)
        // till the whole page is loaded (including redirects, CSS images, script files, frames, DOM processing etc., but excluding any AJAX events)
        fullPageLoadTime = navigationTiming.loadEventEnd - navigationTiming.navigationStart;
        log.trace("Page_Load_Time", fullPageLoadTime);

        // the time from navigation start to fetch start, including redirect time and unload previous page's dom time
        beforeFetchTime = navigationTiming.fetchStart - navigationTiming.navigationStart;
        log.trace("Before_Fetch_Time", beforeFetchTime);

        // the time it takes from the moment the browser initiated a TCP SYN till it received a TCP SYN ACK
        serverConnectionTime = navigationTiming.connectEnd - navigationTiming.connectStart;
        log.trace("Server_Connection_Time", serverConnectionTime);

        dnsLookupTime = navigationTiming.domainLookupEnd - navigationTiming.domainLookupStart;
        log.trace("DNS_Lookup_Time", dnsLookupTime);

        // the time it takes to process body.onload event
        eventLoadTime = navigationTiming.loadEventEnd - navigationTiming.loadEventStart;
        log.trace("Event_Load_Time", eventLoadTime);
    }

    // Each resource name already logged will be pushed to the storedArray to avoid logging duplicated resources
    function logResourceTime(storedArray) {
        var resourceTimeOrigin = window.performance.timing.responseEnd - window.performance.timing.navigationStart;
        var markers = window.performance.getEntriesByType('mark');
        var markerCount = markers.length;
        var allResources = window.performance.getEntriesByType('resource');
        var resourceEntries = _.filter(allResources, function(performanceEntryObj) {
            return _.result(performanceEntryObj, 'name') &&
                !_.contains(storedArray, performanceEntryObj.name) &&
                _.has(allowedResourceInitiatorType, performanceEntryObj.initiatorType) &&
                isTrackableResource(performanceEntryObj);
        });

        _.each(resourceEntries, function (performanceEntryObj) {
            logResourceEntry(performanceEntryObj, allowedResourceInitiatorType[performanceEntryObj.initiatorType]);
            storedArray.push(performanceEntryObj.name);
        });

        if (markerCount > 0) {
            _.each(markers, logMarker);
            performanceApi.clearMarks();
        }

        if (!_.isEmpty(resourceEntries) || markerCount > 0) {
            log.flushLogs();
        }

        function logResourceEntry(resourceEntry, resourceName) {
            var networkLatency
              , networkStart
              , redirectTime
              , responseStartResponseEndTime
              , requestStartResponseEndTime
              , fullResourceLoadTime
              , serverConnectionTime
              , dnsLookupTime
              , duration
              , startTime
              , timingAllowed;

            // Reference [1]: http://www.w3.org/TR/resource-timing/
            // Reference [2]: http://www.sitepoint.com/introduction-resource-timing-api/
            // Primary timings ------------------------------------------------------------------------
            // Start time is relative to page navigation
            startTime = resourceEntry.startTime - resourceTimeOrigin;
            log.trace(resourceMarker("Start_Time"), startTime);

            timingAllowed = resourceEntry.domainLookupStart !== 0 &&
                resourceEntry.connectStart !== 0 &&
                resourceEntry.requestStart !== 0 &&
                resourceEntry.responseStart !== 0;
            if (timingAllowed) {
                networkStart = resourceEntry.domainLookupEnd === resourceEntry.fetchStart
                    ? resourceEntry.connectEnd === resourceEntry.fetchStart
                        ? resourceEntry.requestStart
                        : resourceEntry.connectStart
                    : resourceEntry.domainLookupStart;
                networkLatency = resourceEntry.responseEnd - networkStart;
                log.trace(resourceMarker("Network_Latency"), networkLatency);

                // attempting to compute per-resource queuing/stalling time
                log.trace(resourceMarker("Resource_Scheduling"), networkStart - resourceEntry.fetchStart);
            } else {
                log.trace(resourceMarker("Network_Latency"), PerfTimingNotAvailable);
            }

            fullResourceLoadTime = resourceEntry.responseEnd - resourceEntry.startTime;
            log.trace(resourceMarker("Resource_Load_Time"), fullResourceLoadTime);

            // Duration captures the time from when the resource is identified on the DOM to when it completes the resource downloading.
            // This value can include the time the request is blocked on other parallel resource requests. The definition varies on different browsers.
            // For details, please refer to http://www.stevesouders.com/blog/2014/11/25/serious-confusion-with-resource-timing/
            // This value should be the same as Resource_Load_Time marker
            duration = resourceEntry.duration;
            log.trace(resourceMarker("Duration"), duration);

            redirectTime = resourceEntry.redirectEnd - resourceEntry.redirectStart;
            log.trace(resourceMarker("Redirect_Time"), redirectTime);

            // Additional timings ---------------------------------------------------------------------
            if (timingAllowed) {
                responseStartResponseEndTime = resourceEntry.responseEnd - resourceEntry.responseStart;
                log.trace(resourceMarker("Response_Start_Response_End"), responseStartResponseEndTime);

                requestStartResponseEndTime = resourceEntry.responseEnd - resourceEntry.requestStart;
                log.trace(resourceMarker("Request_Start_ResponseEnd"), requestStartResponseEndTime);

                serverConnectionTime = resourceEntry.connectEnd - resourceEntry.connectStart;
                log.trace(resourceMarker("Server_Connection_Time"), serverConnectionTime);

                dnsLookupTime = resourceEntry.domainLookupEnd - resourceEntry.domainLookupStart;
                log.trace(resourceMarker("DNS_Lookup_Time"), dnsLookupTime);

                log.trace(resourceMarker("Resource_Size"), resourceEntry.decodedBodySize);

                // Transfer size is the size of the payload on network downloading.
                // If the resource is loaded from browser cache, this size is 0
                log.trace(resourceMarker("Transfer_Size"), resourceEntry.transferSize);
            } else {
                log.trace(resourceMarker("Request_Start_ResponseEnd"), PerfTimingNotAvailable);
            }

            function resourceMarker(timing) {
                return resourceName + "_" + timing + ":" + resourceEntry.name;
            }
        }

        function logMarker(marker) {
            log.trace(marker.name, marker.startTime - resourceTimeOrigin);
            log.trace(marker.name + "_Load_Time", marker.startTime);
        }
    }

    // Log the original address of the navigation, that is the entry point address potentially can be followed by a series of redirections
    function logEntryPointAddress() {
        var navigationTiming = window.performance.getEntriesByType('navigation');
        if (navigationTiming && navigationTiming.length > 0) {
            log.trace("Entry_Point_Address", navigationTiming[0].name);
        }
    }

    function isTrackableResource(performanceEntryObj) {
        return !_.find(resourceBlackList, function(str) { return performanceEntryObj.name.indexOf(str) != -1; });
    }

    // http://www.w3.org/TR/navigation-timing/
    // check if Navigation Timing API supported, about 81% supports the navigation timing api
    // (so far Navigation Timing API works in Firefox 7+, Chrome (buggy in 15*) and IE 9+)
    // NOTE: all times are reported in milliseconds since Jan 1, 1970 (UTC)
    function run(writeInterval) {
        // TODO: on a true SPA app, where we stay on the same page forever,
        // this might eventually cause a memory overflow and it'll affect page performance,
        // by repeatedly searching through an increasingly bigger array;
        // way before that, though, the resource timing buffer will become full --
        // need to redesign this function to gradually cleanup already recorded entries from the buffer,
        // instead of adding to the memory pressure
        var storedArray = [];

        var parseInterval = parseInt(writeInterval);
        var writeResourceInterval = parseInterval > 0 ? parseInterval : 5000;

        if (window.performance && window.performance.timing && window.performance.getEntriesByType) {
            logPageLoadTime();
            logEntryPointAddress();
            logResourceTime(storedArray);

            setInterval(function() {
                logResourceTime(storedArray);
            }, writeResourceInterval);
        } else {
            log.trace("Page_Load_Time", PerfTimingNotAvailable);
        }

        log.flushLogs();
    }

    return {
        run: run
    };
});


